export default __webpack_public_path__ + "425f4dceed34d5623d1b8032a0c2d881.png";